import React from 'react';

import { FormattedMessage } from 'react-intl';

import { PIPLELINES_TIMESERIES_DATA_LENGTH } from 'src/components/pipelines/hooks/use-pipelines-timeseries';

import { messages } from '../metric-cards/i18n';
import { Description, ValueDifference } from '../metric-cards/styles';

type AverageChartInfoProps = {
  chartTitle: string;
  difference: string;
  hasDifference: boolean;
  isDifferenceImproved: boolean;
  isDifferenceIncreased: boolean;
  hasLastWeekValue: boolean;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const AverageChartInfo: React.FC<AverageChartInfoProps> = ({
  chartTitle,
  difference,
  hasDifference,
  isDifferenceImproved,
  isDifferenceIncreased,
}) => {
  if (!hasDifference) return null;

  return (
    <Description>
      <FormattedMessage
        {...(isDifferenceIncreased
          ? messages.valueIncreasedDescription
          : messages.valueDecreasedDescription)}
        values={{
          chartTitle,
          numberOfPreviousWeeks: PIPLELINES_TIMESERIES_DATA_LENGTH - 1,
          difference: (
            <ValueDifference isImproved={isDifferenceImproved}>
              {difference}
            </ValueDifference>
          ),
        }}
      />
    </Description>
  );
};
